<!-- eslint-disable -->
<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_lettersField') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfRows') }}
            span(slot="value") {{ parameters.amountOfRows }}
        game-preview-setting
            span(slot="name") {{ $i18n.tc('trainer.trainer_gameFormSetting_letters', 1) }}
            span(slot="value") {{ parameters.selectedLetters.join(', ') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_invertedLetters') }}
            span(slot="value")
                template(v-if="parameters.invertedLetters") {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
                template(v-else) {{ $i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated') }}
</template>

<script>
    /*eslint-disable*/
    import GamePreviewSettings from './GamePreviewSettings.vue'
    import GamePreviewSetting from './GamePreviewSetting.vue'
    import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin'

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [GamePreviewMixin],
        components: {
            GamePreviewSettings,
            GamePreviewSetting
        },
    }
</script>
